module.exports = __webpack_public_path__ + "static/mask-2-23795de7b1b2831e01d4b0c6de954b25.png";